import { render, staticRenderFns } from "./CreateEquivalenceOptions.vue?vue&type=template&id=4e8009c2&scoped=true&"
import script from "./CreateEquivalenceOptions.vue?vue&type=script&lang=ts&"
export * from "./CreateEquivalenceOptions.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEquivalenceOptions.vue?vue&type=style&index=0&id=4e8009c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8009c2",
  null
  
)

export default component.exports